export default "__VITE_ASSET__IwT5JxqH__"